.switch {
  display: inline-block;
  height: 26px;
  min-width: 45px;
  position: relative;
  width: 45px;
}

.switch input {
  display: none;
}

.slider {
  background-color: var(--comp-input-active-background-color);
  border-radius: 34px;
  cursor: pointer;
  inset: 0;
  position: absolute;
  transition: 0.4s;
}

.slider::before {
  background-color: white;
  border-radius: 50%;
  bottom: 4px;
  content: "";
  height: 18px;
  left: 4px;
  position: absolute;
  transition: 0.4s;
  width: 18px;
}

.readOnly,
.readOnly .slider {
  cursor: not-allowed !important;
}

.readOnly {
  opacity: 0.4;
}

input:checked+.slider {
  background-color: var(--theme-blue);
}

input:focus+.slider {
  box-shadow: 0 0 1px var(--theme-blue);
}

input:checked+.slider::before {
  transform: translateX(19px);
}